import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=109243f2&"
import script from "./NewNote.vue?vue&type=script&lang=js&"
export * from "./NewNote.vue?vue&type=script&lang=js&"
import style0 from "./NewNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports